module.exports = "https://coinrabbit.io/_next/static/images/sahad-1ef6857521fd076937aa354ab3de0969.png";